import React from 'react';

export default (Component) =>
  class extends React.Component {
    // eslint-disable-next-line react/static-property-placement
    static get displayName() {
      const name = Component.displayName || Component.name;

      return name ? `WithFocusRestore(${name})` : 'WithFocusRestore';
    }

    componentDidMount() {
      const skipLinksElement = global.document.getElementById('skip-links');

      skipLinksElement.focus();
    }

    render() {
      return <Component {...this.props} />;
    }
  };
